export default [
  {
    path: "/404",
    component: () => import("@/pages/auth/404-page.vue"),
  },
  {
    path: "/login",
    component: () => import("@/pages/auth/login-page.vue"),
  },
  {
    path: "/forbidden",
    component: () => import("@/pages/auth/forbidden-page.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
  {
    path: "/pengguna",
    component: () => import("@/pages/pengguna/pengguna-list.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/pengguna/create",
    component: () => import("@/pages/pengguna/pengguna-create.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/pengguna/update/:id",
    component: () => import("@/pages/pengguna/pengguna-update.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/profil/",
    component: () => import("@/pages/profil/profil-page.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes", "relawan", "user", "verificator", "kepala"],
    },
  },
  {
    path: "/registrasi",
    component: () => import("@/pages/auth/register-page.vue"),
  },
  {
    path: "/update-email",
    component: () => import("@/pages/auth/email-page.vue"),
  },
  {
    path: "/lupa-password",
    component: () => import("@/pages/auth/forgot-password.vue"),
  },
  {
    path: "/pengaturan",
    component: () => import("@/pages/settings/about-settings.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
];
